export default function () {
  const widgetName = 'staticSponsors';
  const widgetOpts = staticSponsorsOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    cardWidgetLoaded: function (data) {
      const widgetData = data.items;

      if (widgetData.length <= 0) {
        $(`#${widgetName}`).remove();
      } else {
        createCustomCards(widgetData);
      }
    },
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: ['all'],
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    textOverImage: true,
    buyNowButton: false,
    moreButton: false,
    showDescription: false,
    maxItemsVisible: 6,
    itemsPerPanel: 1,
  });

  // *********************************************************
  // Function Helpers
  function createCustomCards(widgetData) {
    $(`#${widgetName}`).before('<h2 class="static-sponsors-title">Grand Champion Sponsors</h2>');

    $(`#${widgetName} .card-widget-item`).each(function (x) {
      let $sponsor = $(this);

      $sponsor.find('.card-content').remove();
      $sponsor.removeAttr('target');

      if (widgetData[x].URL == null) {
        $sponsor.removeAttr('href');
      }
    });
  }
}
